import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import {
  Box,
  ButtonBase,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
  Typography,
} from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";
import { useGetCurrentUserQuery } from "src/config/store/services/users-api/users-api";
import { usePopover } from "src/modules/shared/hooks/use-popover/use-popover";
import { useLogout } from "src/modules/shared/hooks/useLogout";
import { LoadingPlaceholder } from "../../../loading-placeholder/loading-placeholder";
import { UserAvatar } from "../../../user-avatar/user-avatar";
import { classes } from "./current-user.styles";

type Props = {
  clickable?: boolean;
};

export const CurrentUser: FC<Props> = ({ clickable = false }) => {
  const { data, isFetching } = useGetCurrentUserQuery({});
  const { anchorEl, open, close, isOpen } = usePopover();

  const { handleLogout } = useLogout();

  if (isFetching || !data) {
    return <LoadingPlaceholder />;
  }

  return (
    <Box sx={classes.root}>
      <Typography variant="caption" color="text.primary">
        <Typography color="text.secondary" variant="caption">
          Hello{" "}
        </Typography>
        {data.firstName} {data.lastName}
      </Typography>

      {clickable ? (
        <ButtonBase
          id="user-avatar"
          sx={classes.root}
          component="div"
          onClick={open}
        >
          <UserAvatar
            photoUrl={data.avatar}
            firstName={data.firstName}
            lastName={data.lastName}
          />
        </ButtonBase>
      ) : (
        <UserAvatar
          photoUrl={data.avatar}
          firstName={data.firstName}
          lastName={data.lastName}
        />
      )}

      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        open={isOpen}
        onClose={close}
        PaperProps={{
          sx: {
            mt: 1.5,
            width: 200,
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuList>
          <MenuItem
            onClick={() => {
              close();
            }}
            component={Link}
            to={"/admin-portal/user/profile"}
          >
            <ListItemIcon>
              <PersonIcon fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText>Profile</ListItemText>
          </MenuItem>
          <MenuItem id="logout-button" onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon fontSize="small" color="primary" />
            </ListItemIcon>
            <ListItemText>Logout</ListItemText>
          </MenuItem>
        </MenuList>
      </Menu>
    </Box>
  );
};
